import React from 'react'
import PropTypes from 'prop-types'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import Box from 'reusecore/src/elements/Box'
import Text from 'reusecore/src/elements/Text'
import Heading from 'reusecore/src/elements/Heading'
import FeatureBlock from '../../../components/FeatureBlock'
import Container from '../../../components/UI/Container'
import { FeatureSliderWrapper } from './cryptoSlides.style'
import Image1 from '../../../assets/image/crypto/slider-1.png'
import Image2 from '../../../assets/image/crypto/slider-2.png'
import Image3 from '../../../assets/image/crypto/slider-3.png'

const images = [
  {
    original:
      'https://storage.googleapis.com/innobelge-websites.appspot.com/sites/mobismile/slides/CM1.jpg'
  },
  {
    original:
      'https://storage.googleapis.com/innobelge-websites.appspot.com/sites/mobismile/slides/CM2.jpg'
  },
  {
    original:
      'https://storage.googleapis.com/innobelge-websites.appspot.com/sites/mobismile/slides/DEL1.jpg'
  },
  {
    original:
      'https://storage.googleapis.com/innobelge-websites.appspot.com/sites/mobismile/slides/DEL2.jpg'
  },
  {
    original:
      'https://storage.googleapis.com/innobelge-websites.appspot.com/sites/mobismile/slides/IM3.jpg'
  },
  {
    original:
      'https://storage.googleapis.com/innobelge-websites.appspot.com/sites/mobismile/slides/main.jpg'
  }
]

const FeatureSlider = ({ row, title, description, sectionSubTitle }) => {
  return (
    <FeatureSliderWrapper id="featureslider">
      <Container noGutter mobileGutter>
        <Box className="row" {...row}>
          <Text {...sectionSubTitle} />
          <FeatureBlock
            title={<Heading {...title} />}
            description={<Text {...description} />}
          />
        </Box>
        <Box className="FeatureSlider">
          <ImageGallery
            items={images}
            className="Slider-img"
            showPlayButton={false}
            showFullscreenButton={false}
            showNav={false}
            showBullets={true}
            autoPlay={false}
          />
        </Box>
      </Container>
    </FeatureSliderWrapper>
  )
}

// Transactions style props
FeatureSlider.propTypes = {
  sectionHeader: PropTypes.object,
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
  row: PropTypes.object
}

// Trusted default style
FeatureSlider.defaultProps = {
  // Trusted section row default style
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    flexBox: true,
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'center'
  },

  title: {
    content: 'Notre réseau de partenaires',
    fontSize: ['24px', '26px', '30px', '36px', '40px'],
    lineHeight: ['30px', '32px', '40px', '50px', '55px'],
    fontWeight: '700',
    color: '#32325d',
    letterSpacing: '-0.010em',
    mb: '20px',
    textAlign: ['center', 'center']
  },

  description: {
    content:
      'Partenaire historique des plus grandes enseignes nationales ( Delhaize, Carrefour, Intermarché, …). Le réseau de diffusion de notre agence marketing couvre l’entièreté de la Belgique.',
    fontSize: '16px',
    fontWeight: '400',
    color: '#525f7f',
    lineHeight: '28px',
    mb: ['25px', '25px', '30px', '30px', '45px'],
    textAlign: ['center', 'center']
  },
  sectionSubTitle: {
    content: '',
    as: 'span',
    textAlign: 'left',
    fontSize: ['16px', '16px', '18px', '20px', '20px'],
    fontFamily: 'Poppins',
    fontWeight: '600',
    lineHeight: '27px',
    color: '#525f7f',
    textAlign: ['center', 'center']
  }
}

export default FeatureSlider
